exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-see-all-properties-wrapper-tooltips .dialog-see-all-properties-wrapper {\n  position: relative;\n  background-color: #FFFFFF;\n  width: 100%;\n  height: 200px;\n  padding: 20px 10px; }\n  .dialog-see-all-properties-wrapper-tooltips .dialog-see-all-properties-wrapper .footer-close-btn {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 10px 0;\n    border-top: 1px solid #dfe1e6;\n    color: #042764; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-see-all-properties/dialog-see-all-properties.component.scss
// module id = 933
// module chunks = 22